import { MdMenu } from "react-icons/md";
import { MdOutlineNotifications } from "react-icons/md";
import IconButton from "./IconButton";
import type { ReactNode, RefObject } from "react";
import React from "react";
import { NavLink } from "react-router-dom";
interface HeaderProps {
  logoSrc?: string;
  logoAlt?: string;
  title?: string;
  notificationCount?: number;
  notificationDropdown?: ReactNode;
  notificationContainerRef?: RefObject<HTMLDivElement | null>;
  onMenuClick: () => void;
  onNotificationClick: () => void;
  showRoleToggle?: boolean;
  activeRoleView?: "employee" | "admin";
  onRoleChange?: (role: "employee" | "admin") => void;
}
function Header({
  logoSrc = "/assets/img/deloitte_logo.svg",
  logoAlt = "Logo",
  title = "Alumni",
  notificationCount = 0,
  notificationDropdown,
  notificationContainerRef,
  onMenuClick,
  onNotificationClick,
  showRoleToggle = false,
  activeRoleView = "employee",
  onRoleChange,
}: HeaderProps) {
  return (
    <header className="text-white bg-black fixed top-0 z-[992] w-full transition-colors ease-in-out">
      <div className="flex justify-between items-center p-4">
        {/* Left Section */}
        <div className="flex items-center">
          <IconButton onClick={onMenuClick}>
            <MdMenu size={24} />
          </IconButton>

          <NavLink to='/home' title={logoAlt} className="ml-4">
            <img
              src={logoSrc}
              alt={logoAlt}
              className="max-h-4"
            />
          </NavLink>

          {title && (
            <div className="text-xl pl-4 ml-4 border-l border-gray-600 leading-[19px]">
              {title}
            </div>
          )}
        </div>

        {/* Right Section */}
        <div className="flex gap-5 items-center pr-2">
          {/* <IconButton
            onClick={onMessageClick}
            badgeCount={messageCount}
          >
            <FiMessageSquare size={20} />
          </IconButton> */}
{showRoleToggle && (<div className="items-center gap-4 hidden sm:flex">
      {/* Employee Label */}
      <span
        className={`text-sm font-normal transition-colors ${
          activeRoleView === "employee"
            ? "text-white"
            : "text-[#BBBCBC]"
        }`}
      >
        Employee
      </span>

      {/* Toggle */}
      <button
        onClick={() => onRoleChange?.(activeRoleView === "employee" ? "admin" : "employee")}
        className={`relative w-[28px] h-1  transition-colors duration-300 ${
          activeRoleView === "admin"
            ? "bg-white"
            : "bg-white"
        }`}
      >
        <div
          className={`absolute top-[-0.5rem] left-[-5px] w-5 h-5 bg-black border border-white rounded-full shadow-md transition-transform duration-300 ${
            activeRoleView === "admin"
              ? "translate-x-4"
              : "translate-x-1"
          }`}
        />
      </button>

      {/* Admin Label */}
      <span
        className={`text-sm font-medium transition-colors ${
          activeRoleView === "admin"
            ? "text-white"
            : "text-[#BBBCBC]"
        }`}
      >
        Admin
      </span>
    </div>)}
           
          <div className="relative" ref={notificationContainerRef}>
            <IconButton
              onClick={onNotificationClick}
              badgeCount={notificationCount}
              ariaLabel="Notifications"
            >
              <MdOutlineNotifications size={22} />
            </IconButton>
            {notificationDropdown}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;